import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        name: '401',
        path: '/401',
        component: () => import('@/views/errorPage/401'),
        hidden: true
    },
    {
        name: '404',
        path: '/404',
        component: () => import('@/views/errorPage/404'),
        hidden: true
    },
    {
        name: 'avoidLogin',
        path: '/avoidLogin',
        component: () => import('@/views/login/avoidLogin'),
        meta: {//不展示首页就不会调用header里面的接口
            fullscreen: true
        }
        // hidden: true
    },
    {
        path: "/login",
        name: "Login",
        component: () => import("@/views/login/index.vue"),
        meta: {
            fullscreen: true
        }
    },
    {
        path: "/testLogin",
        name: "testLogin",
        component: () => import("@/views/login/platLogin.vue"),
        meta: {
            fullscreen: true
        }
    },
    {
        path: "/bigLogin",
        name: "BigLogin",
        component: () => import("@/views/login/bigIndex.vue"),
        meta: {
            fullscreen: true
        }
    }
]

const router = new VueRouter({
    routes
})

router.afterEach(() => {
    const el = document.getElementById('frame-wrapper')
    if (el) {
        el.scrollTop = 0
    }
})
export default router